import { LitElement, html } from 'lit';
import { guardedCustomElement } from '../utils/guarded-custom-element';
import { styles } from './sds-process.styles';
import { property } from 'lit/decorators.js';
import { SDS_HEADING_LEVELS } from '../types';

type HeadingLevels = Exclude<SDS_HEADING_LEVELS, 'h1'>;

export interface SDSProcessProps {
		headingLevel?: HeadingLevels;
}

@guardedCustomElement('sds-process')
export class SDSProcess extends LitElement {
	static override styles = [styles];
	public readonly internals: ElementInternals;

	@property({ type: String, reflect: true, attribute: 'heading-level' }) headingLevel?: SDSProcessProps['headingLevel'];

	constructor() {
		super();
		this.internals = this.attachInternals();
		this.internals.role = 'list';
	}

	override render() {
		return html`<slot></slot>`;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'sds-process': SDSProcess;
	}
}
